import React from 'react';
// import {initLightboxJS} from 'lightbox.js-react';
import {SlideshowLightbox} from 'lightbox.js-react';
import GalleryOne from '../../assets/image/gallery/1.JPG';
import GalleryTwo from '../../assets/image/gallery/2.JPG';
import GalleryThree from '../../assets/image/gallery/3.JPG';
import GalleryFour from '../../assets/image/gallery/4.JPG';
import GalleryFive from '../../assets/image/gallery/5.JPG';
import GallerySix from '../../assets/image/gallery/6.JPG';
import GallerySeven from '../../assets/image/gallery/7.JPG';
import GalleryEight from '../../assets/image/gallery/8.JPG';
import GalleryNine from '../../assets/image/gallery/9.JPG';
import GalleryTen from '../../assets/image/gallery/10.JPG';
import GalleryEleven from '../../assets/image/gallery/11.JPG';
import GalleryTwelve from '../../assets/image/gallery/12.JPG';
import GalleryThirteen from '../../assets/image/gallery/13.JPG';
import GalleryFourteen from '../../assets/image/gallery/14.jpg';
import GalleryFifteen from '../../assets/image/gallery/15.JPG';
import GallerySixteen from '../../assets/image/gallery/16.jpg';
import GallerySeventeen from '../../assets/image/gallery/17.JPG';

function Gallery() {
  return (
    <>
    <div className="gallerySection">
      <h3 className='sectionHeading'>Our Gallery</h3>
      <span className='headingAfterLine'></span>
    <div className="galleryWrap">
    <SlideshowLightbox className="gallery galleryLeft">
    <img className="w-full rounded galleryImage" src={GalleryOne} alt='galleryImage' />
    <img className="w-full rounded galleryImage" src={GalleryTwo} alt='galleryImage' />
    <img className="w-full rounded galleryImage" src={GalleryThree} alt='galleryImage' />
    <img className="w-full rounded galleryImage" src={GalleryFour} alt='galleryImage' />
    <img className="w-full rounded galleryImage" src={GalleryFive} alt='galleryImage' />
    <img className="w-full rounded galleryImage" src={GallerySix} alt='galleryImage' />
    <img className="w-full rounded galleryImage" src={GallerySeven} alt='galleryImage' />
    </SlideshowLightbox> 
    <SlideshowLightbox className="galleryMiddle gallery">
    <img className="w-full rounded galleryImage" src={GalleryEight} alt='galleryImage' />
    <img className="w-full rounded galleryImage" src={GalleryNine} alt='galleryImage' />
    <img className="w-full rounded galleryImage" src={GalleryTen} alt='galleryImage' />
    </SlideshowLightbox>
    <SlideshowLightbox className="gallery galleryRight">
    <img className="w-full rounded galleryImage" src={GalleryEleven} alt='galleryImage' />
    <img className="w-full rounded galleryImage" src={GalleryTwelve} alt='galleryImage' />
    <img className="w-full rounded galleryImage" src={GalleryThirteen} alt='galleryImage' />
    <img className="w-full rounded galleryImage" src={GalleryFourteen} alt='galleryImage' />
    <img className="w-full rounded galleryImage" src={GalleryFifteen} alt='galleryImage' />
    <img className="w-full rounded galleryImage" src={GallerySixteen} alt='galleryImage' />
    <img className="w-full rounded galleryImage" src={GallerySeventeen} alt='galleryImage' />
    </SlideshowLightbox>
    
    </div>
    </div>
    </>
  )
}

export default Gallery
